import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Document,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/documents`;

export interface GetClaimDocumentsRequestArgs {
  claimId: string;
}

export const getClaimDocumentsRequest = ({
  claimId,
}: GetClaimDocumentsRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimDocumentsQuery = async (
  payload: GetClaimDocumentsRequestArgs,
): Promise<BackResponse<Document[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Document[]>>(
      getClaimDocumentsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
